import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { GlobalSearch, IGlobalSearchUIProps } from '../components/GlobalSearch'
import {
  actionCreators,
  IGlobalSearchInstanceState,
  selectError,
  selectIsSearching,
  selectResults,
} from '../modules/globalSearch'

export default connect(
  (state: ApplicationState, ownProps: IGlobalSearchUIProps) =>
    createStructuredSelector<ApplicationState, IGlobalSearchInstanceState>({
      error: selectError(),
      isSearching: selectIsSearching(),
      results: selectResults(ownProps.id),
    }),
  actionCreators,
)(GlobalSearch)
